module.exports = __webpack_public_path__ + "img/QOOKER_Box21.bddc9f39.jpg";